var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4517 2.69498C19.7485 2.61404 19.9603 2.97901 19.7428 3.19654L13.2708 9.66854L7.26088 6.93677C6.83472 6.74306 6.8846 6.12237 7.33622 5.9992L19.4517 2.69498Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0632 16.7391L14.3314 10.7292L20.8034 4.25719C21.021 4.03966 21.3859 4.25146 21.305 4.54826L18.0008 16.6638C17.8776 17.1154 17.2569 17.1653 17.0632 16.7391Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5303 13.5303C11.8232 13.2374 11.8232 12.7626 11.5303 12.4697C11.2374 12.1768 10.7626 12.1768 10.4697 12.4697L6.46967 16.4697C6.17678 16.7626 6.17678 17.2374 6.46967 17.5303C6.76256 17.8232 7.23744 17.8232 7.53033 17.5303L11.5303 13.5303Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53033 12.4697C7.82322 12.7626 7.82322 13.2374 7.53033 13.5303L3.53033 17.5303C3.23744 17.8232 2.76256 17.8232 2.46967 17.5303C2.17678 17.2374 2.17678 16.7626 2.46967 16.4697L6.46967 12.4697C6.76256 12.1768 7.23744 12.1768 7.53033 12.4697Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5303 17.5303C11.8232 17.2374 11.8232 16.7626 11.5303 16.4697C11.2374 16.1768 10.7626 16.1768 10.4697 16.4697L6.46967 20.4697C6.17678 20.7626 6.17678 21.2374 6.46967 21.5303C6.76256 21.8232 7.23744 21.8232 7.53033 21.5303L11.5303 17.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.471dc84b64a4a616732d80fd30bd0d37.svg";
export { ForwardRef as ReactComponent };